export const boardsTypesTexts = {
  BOARD: 'Board',
  BASIC_BOARD: 'Board',
  COUNCIL: 'Council',
};
